import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as engagements from '../../engagements'

export const RESOURCE = {
  payload: {
    description:
      'Represents a relationship between an employee and a project, which a description of their role on that project and the time and hours billed towards that project. Also represents an employees availability.',
    dimension: engagements.RESOURCE.payload,
    level: 0,
    name: 'Engagement',
    partialId: PartialId.Standard.create('engagement'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
